import { atom } from 'jotai';
import PriceFilterButton from 'components/search/v2/Filter/contents/PriceFilterButton';
import PassengersFilterButton from 'components/search/v2/Filter/contents/PassengersFilterButton';
import CaptainFilterButton from './contents/CaptainFilterButton';
import {
  isAnyFilterActiveAtom,
  isCaptainFilterActiveAtom,
  isCaptainSearchModeAtom,
  isPriceFilterActiveAtom,
  passengersFilterActiveAtom,
} from './filterStore';
import OtherFiltersFilterButton from './contents/OtherFiltersFilterButton';
import DurationFilterButton from './contents/DurationFilterButton';
// import {
//   isExperienceSubtagActiveAtom,
//   isExperienceSubtagHiddenAtom,
//   ExperienceSubTagsContent,
//   ExperienceSubTagsLabel
// } from './contents/ExperienceSubTags';
// eslint-disable-next-line import/prefer-default-export
export const getFilterButtons = () => [
  {
    name: 'filters',
    CustomButton: OtherFiltersFilterButton,
    isFilterHiddenAtom: atom(false),
    isFilterActiveAtom: isAnyFilterActiveAtom,
  },
  // TODO use this when we remove the feature flag
  // {
  //   name: 'experience_sub_tags',
  //   isFilterHiddenAtom: isExperienceSubtagHiddenAtom,
  //   isFilterActiveAtom: isExperienceSubtagActiveAtom,
  // },
  {
    name: 'price',
    isFilterActiveAtom: isPriceFilterActiveAtom,
    isFilterHiddenAtom: atom(false),
    CustomButton: PriceFilterButton,
  },
  {
    name: 'duration',
    CustomButton: DurationFilterButton,
    isFilterHiddenAtom: atom(false),
    isFilterActiveAtom: isCaptainFilterActiveAtom,
  },
  {
    name: 'package_type',
    CustomButton: CaptainFilterButton,
    isFilterActiveAtom: isCaptainFilterActiveAtom,
    isFilterHiddenAtom: isCaptainSearchModeAtom,
  },
  {
    name: 'passengers',
    CustomButton: PassengersFilterButton,
    isFilterActiveAtom: passengersFilterActiveAtom,
    isFilterHiddenAtom: atom(false),
  },

  //   ]
  // : []),
];
